import { createReducer } from '../../store.model';

import { ActionType } from './main.action';
import { defaultState, MainState } from './main.state';
import { ApplyFilterSelection } from './state/apply-filter-selection.action';
import { applyFilterSelectionReducer } from './state/apply-filter-selection.reducer';
import { Reload, ReloadResult } from './state/reload.action';
import { reloadReducer, reloadResultReducer } from './state/reload.reducer';
import {
    HidePopulationGroupDialog,
    ShowPopulationGroupDialog,
} from './state/show-population-group-dialog.action';
import {
    hidePopulationGroupDialogReducer,
    showPopulationGroupDialogReducer,
} from './state/show-population-group-dialog.reducer';
import {
    HideTrendDialog,
    ShowTrendDialog,
    ShowTrendDialogResult,
} from './state/show-trend-dialog.action';
import {
    hideTrendDialogReducer,
    showTrendDialogReducer,
    showTrendDialogResultReducer,
} from './state/show-trend-dialog.reducer';
import { SortRows } from './state/sort-rows.action';
import { sortRowsReducer } from './state/sort-rows.reducer';
import { ToggleFilterButton } from './state/toggle-filter-button.action';
import { toggleFilterButtonReducer } from './state/toggle-filter-button.reducer';
import { ToggleFilterCategory } from './state/toggle-filter-category.action';
import { toggleFilterCategoryReducer } from './state/toggle-filter-category.reducer';
import { ToggleFilterGroup } from './state/toggle-filter-group.action';
import { toggleFilterGroupReducer } from './state/toggle-filter-group.reducer';

const { reducer, builder } = createReducer<ActionType, MainState>(
    defaultState(),
);

builder
    .add<Reload>(ActionType.MI2_MAIN__RELOAD, reloadReducer)
    .add<ReloadResult>(ActionType.MI2_MAIN__RELOAD_RESULT, reloadResultReducer);

builder.add<SortRows>(ActionType.MI2_MAIN__SORT_ROWS, sortRowsReducer);

builder.add<ToggleFilterCategory>(
    ActionType.MI2_MAIN__TOGGLE_FILTER_CATEGORY,
    toggleFilterCategoryReducer,
);

builder.add<ToggleFilterGroup>(
    ActionType.MI2_MAIN__TOGGLE_FILTER_GROUP,
    toggleFilterGroupReducer,
);

builder.add<ApplyFilterSelection>(
    ActionType.MI2_MAIN__APPLY_FILTER_SELECTION,
    applyFilterSelectionReducer,
);

builder.add<ToggleFilterButton>(
    ActionType.MI2_MAIN__TOGGLE_FILTER_BUTTON,
    toggleFilterButtonReducer,
);

builder
    .add<ShowPopulationGroupDialog>(
        ActionType.MI2_MAIN__SHOW_POPULATION_GROUP_DIALOG,
        showPopulationGroupDialogReducer,
    )
    .add<HidePopulationGroupDialog>(
        ActionType.MI2_MAIN__HIDE_POPULATION_GROUP_DIALOG,
        hidePopulationGroupDialogReducer,
    );

builder
    .add<ShowTrendDialog>(
        ActionType.MI2_MAIN__SHOW_TREND_DIALOG,
        showTrendDialogReducer,
    )
    .add<ShowTrendDialogResult>(
        ActionType.MI2_MAIN__SHOW_TREND_DIALOG_RESULT,
        showTrendDialogResultReducer,
    )
    .add<HideTrendDialog>(
        ActionType.MI2_MAIN__HIDE_TREND_DIALOG,
        hideTrendDialogReducer,
    );

export const mainReducer = reducer;
